/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// component
import Configuration from 'pages/dashboard/commenting/configuration/configuration';



/* ========== ~~~~~~~~~~ COMMENTING CONFIGURATION : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ commentingState }) => ({

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
)(Configuration));
